"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStackedBarTooltipData = exports.getStackedData = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
exports.getStackedData = function (data) {
    return data.groupedData.map(function (d) {
        var newValues = {};
        d.values.forEach(function (v) {
            newValues[v.subGroupID + "_" + v.aggregateTypeID] = v.y;
        });
        var stackedBar = d3
            .stack()
            .offset(d3.stackOffsetDiverging)
            .keys(Object.keys(newValues))([newValues])
            .map(function (stack) {
            return {
                y0: stack[0][0],
                y1: stack[0][1],
                key: stack.key,
            };
        });
        return stackedBar;
    });
};
exports.getStackedBarTooltipData = function (subGroups, aggregateTypes, group) {
    var tooltipData = aggregateTypes.map(function (aggregateType) {
        var values = subGroups.map(function (subGroup) {
            var value = group.values.find(function (v) {
                return v.subGroupID === subGroup.ID && v.aggregateTypeID === aggregateType.ID;
            });
            return tslib_1.__assign(tslib_1.__assign({}, subGroup), { value: value ? value.y : null });
        });
        var isRowBlank = values.every(function (row) {
            return (row === null || row === void 0 ? void 0 : row.value) === null;
        });
        return tslib_1.__assign(tslib_1.__assign({}, aggregateType), { values: isRowBlank ? [] : values });
    });
    var filteredTooltipData = tooltipData.filter(function (aggregateType) { return !isEmpty_1.default(aggregateType.values); });
    return filteredTooltipData;
};
